/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's copyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

import React from 'react';
import { cn } from '@/shared/ui/utils/tailwind';

type LinkProps = {
  onlyBehavior?: boolean;
  href?: string;
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  [key: string]: any;
};

/**
 * Link component for styled anchor elements.
 *
 * @param {LinkProps} props - Link properties.
 * @returns {JSX.Element} Rendered anchor.
 */
const Link: React.FC<LinkProps> = ({
  onlyBehavior = false,
  children,
  className,
  style,
  ...props
}) => {
  return (
    <a
      className={cn(
        'text-sm rounded-none',
        onlyBehavior
          ? 'text-inherit no-underline contents'
          : 'text-[var(--link-text)] hover:underline',
        className
      )}
      style={style}
      {...props}
    >
      {children}
    </a>
  );
};

export default Link;
